<template>
  <v-card class="elevation-12">
    <v-card-title class="px-9 pt-7">
      Rezervovaná kapacita
    </v-card-title>

    <v-card-text>
      <v-row class="align-center">
        <v-col cols="auto" class="request-label">Roční rezervovaná kapacita:</v-col>

        <v-col cols="3">
          <div
            class="font-weight-bold text-h6"
          >
            {{
              value.annualBookedCapacity
                ? value.annualBookedCapacity
                : '-'
            }}
            kW
          </div>
        </v-col>
      </v-row>

      <div
        class="mb-6"
        v-for="monthlyBookedCapacity in value.monthlyBookedCapacities"
        :key="monthlyBookedCapacity.index"
      >
        <v-row>
          <v-col
            class="pb-0 px-1 text-center font-weight-bold"
            cols="1"
            v-for="bookedCapacity in monthlyBookedCapacity.values"
            :key="bookedCapacity.index"
          >
            {{ `${bookedCapacity.month}/${monthlyBookedCapacity.year}` }}
          </v-col>
        </v-row>

        <v-divider color="black" class="my-1"></v-divider>

        <v-row>
          <v-col
            class="pb-0 px-1"
            cols="1"
            v-for="bookedCapacity in monthlyBookedCapacity.values"
            :key="bookedCapacity.index"
          >
            <input
              class="reserved-capacity-input white-placeholder text-center"
              type="text"
              disabled
              v-model="bookedCapacity.value"
              placeholder="-"
              :style="`background-color: ${colors.bookedCapacity};`"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            class="pb-0 px-1"
            cols="1"
            v-for="bookedCapacity in monthlyBookedCapacity.values"
            :key="bookedCapacity.index"
          >
            <input
              class="reserved-capacity-input white-placeholder text-center white--text"
              type="text"
              disabled
              v-model="bookedCapacity.maxValue15min"
              placeholder="-"
              :style="`background-color: ${colors.maxValue15min};`"
            />
          </v-col>
        </v-row>
      </div>

      <v-row>
        <v-col cols="auto">
          <SquareLegend
            :backgroundColor="colors.bookedCapacity">
            Měsíční rezervovaná kapacita [kW]
          </SquareLegend>
        </v-col>

        <v-col cols="auto">
          <SquareLegend
            :backgroundColor="colors.maxValue15min">
            Měsíční ¼ hodinové maximum [kW]
          </SquareLegend>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import SquareLegend from '@/components/SquareLegend.vue';

export default {
  name: 'CollectionPointReservedCapacity',
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
  },
  components: {
    SquareLegend,
  },
  data() {
    return {
      colors: {
        bookedCapacity: '#c6d8f0',
        maxValue15min: '#242f65',
      },
    };
  },
};
</script>

<style lang="scss">
.reserved-capacity-input {
  width: 100%;
  color: rgba(0, 0, 0, 0.75);
  border-radius: 1px;
  height: 40px;
}

.white-placeholder::placeholder {
  color: #fff;
}

.white-placeholder::-ms-input-placeholder {
  color: #fff;
}
</style>
